import { useState } from 'react';
import { Col, Row, Image, Menu } from 'antd';
import styles from '../styles/ToggleableDiv.module.css';
import Layout from './Layout';
import boticon from "../icons/boticon.png";

import { useSession } from "next-auth/react";
const ToggleableDiv = ({ children }) => {
    const { data: session } = useSession();
    const [isVisible, setIsVisible] = useState(false);

    const handleClose = () => {
        setIsVisible(false);
    };

    const handleOpen = () => {
        setIsVisible(true);
    };

    return (
        <>
            <div>{children}</div>
            {session ? (<div>
                {isVisible ? (
                    <div className={styles.toggleableDiv}>
                        <button onClick={handleClose} className={styles.closeButton}>
                            &times; {/* Close button symbol */}
                        </button>
                        <div className={styles.content}>

                            <iframe

                                src="https://chatbotdockervm.eastus.cloudapp.azure.com/chatbot_window?origin=awc"
                                style={{
                                    border: 'none',
                                    width: '420px',
                                    height: '400px'
                                }}
                                scrolling="no"
                            />
                        </div>
                    </div>
                ) : (
                    <>
                        {/* <Image
                            src='/images/boticon.png'
                            alt="Open Bot"
                            width={130}
                            height={150}
                            className={styles.openImage}
                            onClick={handleOpen}
                        /> */}
                    </>

                )}
            </div>) : <div></div>}
        </>
    );
};

export default ToggleableDiv;
